export default __webpack_public_path__ + "static/media/yada.fe23c47e.png";